import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';

import LOGO from '../../img/logo.svg';

let NewPasswordForm = (props) => {

    const {handleSubmit,pristine,submitting} = props;

    return (
        <div className="form">
            <form onSubmit={handleSubmit}>
                <div className="form_logo">
                    <Link to={'/'}><img src={LOGO} alt="Reliance HMO's Logo"/></Link>
                </div>
                <Field component="input" type="password" name="password" placeholder="New Password (6 characters minimum)" required/>
                <Field component="input" type="password" name="confirm_password" placeholder="Confirm Password (6 characters minimum)" required/>
                <Field component="input" type="hidden" name="token" />
                <Field component="input" type="hidden" name="expire" />
                <button type="submit" disabled={pristine||submitting}>SUBMIT</button>
            </form>
        </div>
    )
};


NewPasswordForm = reduxForm({
    form:'newPasswordForm'
})(NewPasswordForm);

export default NewPasswordForm